import https from "./https"
import store from "@/store"

const cresclabMenuApi = {
  async listAvailableInstitutions() {
    const organization = store.state.liffGeneral.orgCode
    return https.get(`${organization}/liff/cresclab-menu/available-institutions`)
  },
  async updateSelectedInstitution(institutionTagName) {
    const organization = store.state.liffGeneral.orgCode
    return https.put(`${organization}/liff/cresclab-menu/selected-institution`, { tag: institutionTagName })
  },
  async getTargetInstitution(targetTag) {
    const organization = store.state.liffGeneral.orgCode
    return https.get(`${organization}/liff/cresclab-menu/target-institution/${targetTag}`)
  },
}

export default cresclabMenuApi
